"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/FirstTimeTooltips.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);




var _ = require('web/components/Tooltip/');

var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _firstTimeTutorial = require('web/actions/firstTimeTutorial');
var _firstTimeTutorial3 = require('web/reducers/firstTimeTutorial');
var _hooks = require('web/services/hooks');





const shouldRenderTooltip = (
  activeInteractable,
  tooltipId,
) =>
  activeInteractable &&
  activeInteractable.id === tooltipId &&
  activeInteractable.isPermitted

// Each wrapper is memoized, as connect() was.
 const WithFirstChatTooltip = _react.memo.call(void 0, function WithFirstChatTooltip ({ children }) {
  const interactable = _hooks.useAppSelector.call(void 0, _firstTimeTutorial3.selectActiveInteractable)
  const tooltipId = _firstTimeTutorial.firstTimeTooltipIds.FIRST_CHAT
  if (!shouldRenderTooltip(interactable, tooltipId)) return children

  const hint = (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement(_.TooltipTitle, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 33}}, "You've just got a new message"     )
      , _react2.default.createElement(_.TooltipInfo, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 34}}, "Click on it to read the conversation. All your future chats will appear in this list."               )
    )
  )

  return (
    _react2.default.createElement(_.ControlledTooltip, {
      type: "light",
      place: "right",
      isOpen: true,
      isAnimated: true,
      hasCloseButton: true,
      content: hint,
      tooltipClassName: "first-time--tooltip",
      onClose: () => _actions2.default.dismissInteractableById(_firstTimeTutorial.firstTimeTooltipIds.FIRST_CHAT), __self: this, __source: {fileName: _jsxFileName, lineNumber: 39}}

      , children
    )
  )
}); exports.WithFirstChatTooltip = WithFirstChatTooltip

 const WithCreateNewButtonTooltip = _react.memo.call(void 0, function WithCreateNewButtonTooltip ({ children }) {
  const interactable = _hooks.useAppSelector.call(void 0, _firstTimeTutorial3.selectActiveInteractable)
  const tooltipId = _firstTimeTutorial.firstTimeTooltipIds.CREATE_NEW_BUTTON
  if (!shouldRenderTooltip(interactable, tooltipId)) return children
  const hint = (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement(_.TooltipTitle, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 60}}, "Send a new message"   )
      , _react2.default.createElement(_.TooltipInfo, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 61}}, "Your coworkers and patients are here. To send a message click this button."            )
    )
  )

  return (
    _react2.default.createElement(_.ControlledTooltip, {
      type: "light",
      place: "bottom",
      isOpen: true,
      isAnimated: true,
      hasCloseButton: true,
      content: hint,
      tooltipClassName: "first-time--tooltip",
      onClose: () => _actions2.default.dismissInteractableById(tooltipId), __self: this, __source: {fileName: _jsxFileName, lineNumber: 66}}

      , children
    )
  )
}); exports.WithCreateNewButtonTooltip = WithCreateNewButtonTooltip

 const WithSwitchInboxTooltip = _react.memo.call(void 0, function WithSwitchInboxTooltip ({ children }) {
  const interactable = _hooks.useAppSelector.call(void 0, _firstTimeTutorial3.selectActiveInteractable)
  const tooltipId = _firstTimeTutorial.firstTimeTooltipIds.SWITCH_INBOX
  if (!shouldRenderTooltip(interactable, tooltipId)) return children

  const hint = (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement(_.TooltipTitle, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 88}}, "Switch to another Inbox"   )
      , _react2.default.createElement(_.TooltipInfo, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 89}}, "You can jump to any team's inbox so it's easier to find chats between specific teams and patients."                 )
    )
  )

  return (
    _react2.default.createElement(_.ControlledTooltip, {
      type: "light",
      place: "bottom",
      isOpen: shouldRenderTooltip(interactable, tooltipId),
      isAnimated: true,
      hasCloseButton: true,
      content: hint,
      tooltipClassName: "first-time--tooltip",
      onClose: () => _actions2.default.dismissInteractableById(tooltipId), __self: this, __source: {fileName: _jsxFileName, lineNumber: 94}}

      , children
    )
  )
}); exports.WithSwitchInboxTooltip = WithSwitchInboxTooltip

 const WithProfileTooltip = _react.memo.call(void 0, function WithProfileTooltip ({ children }) {
  const interactable = _hooks.useAppSelector.call(void 0, _firstTimeTutorial3.selectActiveInteractable)
  const tooltipId = _firstTimeTutorial.firstTimeTooltipIds.PROFILE
  if (!shouldRenderTooltip(interactable, tooltipId)) return children

  const hint = (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement(_.TooltipTitle, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 116}}, "Access your Profile"  )
      , _react2.default.createElement(_.TooltipInfo, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 117}}, "Change your profile avatar and email, add phone numbers, manage your organization members and much more in Settings."                 )
    )
  )

  return (
    _react2.default.createElement(_.ControlledTooltip, {
      type: "light",
      // You sit at the foot of the sidebar.
      place: "top",
      isOpen: true,
      isAnimated: true,
      hasCloseButton: true,
      content: hint,
      tooltipClassName: "first-time--tooltip",
      onClose: () => _actions2.default.dismissInteractableById(tooltipId), __self: this, __source: {fileName: _jsxFileName, lineNumber: 122}}

      , children
    )
  )
}); exports.WithProfileTooltip = WithProfileTooltip
